<template>
  <div>
    <Button
      :disabled="!selAll.length"
      @click="exportBtn"
      style="margin-bottom:10px"
      type="primary"
      >{{ $t("export") }}</Button
    >
    <Table
      border
      :columns="tableTitle"
      :data="list"
      stripe
      :height="600"
      :loading="loading"
      @on-selection-change="selectTableAll"
    >
    </Table>
    <Page
      ref="pageSize"
      :page-size-opts="arrPageSize"
      :total="total"
      show-sizer
      :page-size="searchFrom.pageSize"
      @on-page-size-change="changeSize"
      @on-change="changePage"
      show-elevator
      show-total
      class-name="page-content"
      :current.sync="pageCurrent"
      @pageClick="submitSearch"
    />
  </div>
</template>

<script>
import { getShelvesLog, getPickupLog, getOutLog } from "@/api/storage/stock";
import paging from "@/utils/page";
import excel from "@/utils/excel";

export default {
  props: {
    skuId: {
      type: Number
    },
    crudText: {
      type: String
    },
    warehouse_id: {
      type: Number
    }
  },
  data() {
    return {
      arrPageSize: [15, 50, 100, 500],
      maskClosable: false,
      loading: true,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
        warehouse_id: "",
        sku_id: ""
      },
      pageCurrent: 1,
      total: 0,
      selAll: []
    };
  },
  computed: {
    tableTitle() {
      if (this.crudText == "already_listed_number") {
        return [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: this.$t("operation") + this.$t("time"),
            key: "location_time",
            align: "center",
            tooltip: true,
            minWidth: 200
          },
          {
            title: this.$t("warehouse"),
            key: "warehouse_name",
            align: "center",
            tooltip: true,
            minWidth: 100
          },
          {
            title: this.$t("location_t"),
            key: "location",
            align: "center",
            tooltip: true,
            minWidth: 200
          },
          {
            title: this.$t("des_goods"),
            key: "sku_name",
            align: "center",
            tooltip: true,
            minWidth: 100
          },
          {
            title: "sku",
            key: "bar_code",
            align: "center",
            tooltip: true,
            minWidth: 200
          },
          {
            title: this.$t("supplier"),
            key: "account",
            align: "center",
            tooltip: true,
            minWidth: 100
          },
          {
            title: this.$t("noofpieces"),
            key: "number",
            align: "center",
            tooltip: true,
            minWidth: 100
          },
          {
            title: this.$t("operation") + this.$t("type"),
            align: "center",
            key: "direction_t",
            tooltip: true,
            minWidth: 100
          }
        ];
      }
      if (this.crudText == "not_listed_number") {
        return [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: this.$t("placeOrder") + this.$t("time"),
            key: "create_time",
            align: "center",
            tooltip: true,
            minWidth: 200
          },
          {
            title: this.$t("outbound") + this.$t("time"),
            key: "send_time",
            align: "center",
            tooltip: true,
            minWidth: 200
          },
          {
            title: this.$t("outbound") + this.$t("Odd_Numbers"),
            key: "airway_number",
            align: "center",
            tooltip: true,
            minWidth: 100
          },
          {
            title: this.$t("skuName"),
            key: "sku_name",
            align: "center",
            tooltip: true,
            minWidth: 100
          },
          {
            title: this.$t("barCode"),
            key: "bar_code",
            align: "center",
            tooltip: true,
            minWidth: 200
          },
          {
            title: this.$t("price_t"),
            key: "declaration_amount",
            align: "center",
            tooltip: true,
            minWidth: 100
          },
          {
            title: this.$t("noofpieces"),
            key: "pickup_number",
            align: "center",
            tooltip: true,
            minWidth: 100
          }
        ];
      }
      return [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("placeOrder") + this.$t("time"),
          key: "create_time",
          align: "center",
          tooltip: true,
          minWidth: 200
        },
        {
          title: this.$t("outbound") + this.$t("Odd_Numbers"),
          key: "airway_number",
          align: "center",
          tooltip: true,
          minWidth: 100
        },
        {
          title: this.$t("skuName") + this.$t("Odd_Numbers"),
          key: "sku_name",
          align: "center",
          tooltip: true,
          minWidth: 100
        },
        {
          title: this.$t("barCode"),
          key: "bar_code",
          align: "center",
          tooltip: true,
          minWidth: 200
        },
        {
          title: this.$t("price_t"),
          key: "declaration_amount",
          align: "center",
          tooltip: true,
          minWidth: 100
        },
        {
          title: this.$t("noofpieces"),
          key: "pickup_number",
          align: "center",
          tooltip: true,
          minWidth: 100
        }
      ];
    }
  },
  mounted() {
    this.searchFrom.sku_id = this.skuId;
    this.searchFrom.warehouse_id = this.warehouse_id;
    this.getList(this.searchFrom);
  },
  methods: {
    selectTableAll(val) {
      console.log(val);
      this.selAll = val;
    },
    exportBtn() {
      excel.exportExcel(
        this.selAll,
        this.tableTitle.slice(1),
        this.$t(this.crudText),
        this
      );
    },
    changeSize(val) {
      paging.changeSize(val, this, 1);
    },
    changePage(val) {
      paging.changePage(val, this, 1);
    },
    submitSearch(data) {
      this.getList(data);
    },
    getList(data) {
      this.loading = true;
      if (this.crudText == "already_listed_number") {
        getShelvesLog(data).then(res => {
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows;
          this.list = res.data.payload.rows.map(item => {
            item.direction_t =
              item.direction == 0 ? this.$t("up") : this.$t("down");
            return item;
          });
          this.loading = false;
        });
        return;
      }
      if (this.crudText == "not_listed_number") {
        getPickupLog(data).then(res => {
          this.total = res.data.payload.total;
          this.list = res.data.payload.rows;
          this.loading = false;
        });
        return;
      }
      getOutLog(data).then(res => {
        this.total = res.data.payload.total;
        this.list = res.data.payload.rows;
        this.loading = false;
      });
    }
  }
};
</script>
<style scoped></style>
